module.exports = __webpack_public_path__ + "img/tag_center.c975e757.svg";